<template>
    <div id="learning">
        <div class="nav-space"></div>
        <LearningTimeline />
        <LearningProject />
    </div>
</template>

<script>
import LearningTimeline from '../components/learningSections/LearningTimeline.vue'
import LearningProject from '../components/learningSections/LearningProject.vue'

export default {
    name: 'Learning',
    components: { LearningTimeline, LearningProject },
}
</script>

<style scoped>
#learning{
    width: 100%;
    min-width: 1300px;
    background-image: url(../assets/background/tech.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
}

.nav-space{
    height: 50px;
    background-color: #181e2def;
}
</style>